import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppState } from '../../core';
import { TmoLocationLogRecord } from '../../core/models/tmo-location-log-record';
import { PostProcessingService } from '../../core/services';
import { TableColumn, TableViewComponentBase, TableViewQueryRequest } from '../../shared/components/table-view/table-view-component-base';

//
// Display rows from one or more location logs in same table.  
// For example if you search by date, rows from tmobile log and 
// other carriers will be displayed together
//
@Component({
  selector: 'app-tmo-location-logs',
  templateUrl: '../../shared/components/table-view/table-view.component.html',
  styleUrls: [
    '../../shared/components/table-view/scss/table-view.scss',
    '../../shared/components/table-view/scss/app-tab-full-height.scss',
    '../../shared/components/table-view/scss/fixed-headers-and-column.scss',
  ]
})
export class TmoLocationLogsComponent extends TableViewComponentBase<TmoLocationLogRecord> implements OnInit, OnDestroy {


  constructor(
      appState: AppState,
      modalService: BsModalService,
      public postProcessingService: PostProcessingService,
      elementRef: ElementRef,
      datePipe: DatePipe
  ){
    super(appState,modalService,elementRef,datePipe)
    this.tableColumns = []
    for( let objKey in new TmoLocationLogRecord() ) {
      let columnMeta : any = {title:objKey,name:objKey,visible:true}
      switch(objKey) {
        case 'id':
          columnMeta.template = 'locationLink'
          break;
        case 'ascertained':
          columnMeta.template = 'correlationLink'
          break;
        case 'gpsascertained':
          columnMeta.template = 'time'
          break;
      }
      this.tableColumns.push(columnMeta)
    }
    ['header','filter','data'].forEach((cellPrefix,index)=>{
      // give every cell a class to identify column
      this.tableColumns.forEach((c,index)=>c[cellPrefix+'CellCssClass']='column-' + index)
    })
  }


  ngOnInit(): void {
    this.init()
  }


  ngOnDestroy(): void {
    this.destroy()
  }

  isDateColumn = ( column : TableColumn ) => {
    return column.template == 'time' || column.name == 'ascertained'
  }
  
  doQuery = async (queryReq:TableViewQueryRequest) => this.postProcessingService.findTmoLocationLogRecords(queryReq)

  getName = () => 'tmo-location-logs'
}
